import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback, useEffect, useState } from "react";
import type { ICandidateData } from "types/candidateData";
import { logger } from "utils/helpers/logger";
import { checkIfGetMichiganTokenExists, getMichiganToken, parseMichiganToken } from "utils/helpers/pracujMobile";
const getCandidateData = async ({
  token,
  userId
}: {
  token: string;
  userId: string;
}): Promise<ICandidateData> => {
  const body = {
    token,
    userId
  };
  const res = await fetch("/api/forms/pracujCandidateData", {
    method: "POST",
    body: JSON.stringify(body)
  });
  return res.json();
};
export const usePracujMobileCandidate = () => {
  const params = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const [isFetching, setIsFetching] = useState(false);
  const [candidateData, setCandidateData] = useState<ICandidateData | null>(null);
  const updateParam = useCallback(() => {
    const newParams = new URLSearchParams(params.toString());
    newParams.set("filledFromPracujMobile", "true");
    router.replace(`${pathname}?${newParams.toString()}`);
  }, [params, pathname, router]);
  useEffect(() => {
    const fillFromPracujMobile = async () => {
      try {
        if (candidateData || !checkIfGetMichiganTokenExists()) {
          return;
        }
        setIsFetching(true);
        const michiganToken = getMichiganToken();
        if (michiganToken) {
          const {
            token,
            userId
          } = parseMichiganToken(michiganToken);
          if (token && userId) {
            const resp = await getCandidateData({
              token,
              userId
            });
            if (resp) {
              updateParam();
              setCandidateData(resp);
            }
          }
        }
      } catch (error) {
        logger.error("Error while fetching candidate data", error);
      } finally {
        setIsFetching(false);
      }
    };
    fillFromPracujMobile();
  }, [candidateData, updateParam]);
  return {
    candidateData,
    isFetching
  };
};